import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { BaseModalComponent } from '../../../models/base-modal-component';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { CommonService } from '../../../services/common/common.service';
import { RestService } from '../../../services/rest/rest.service';
import { Endpoint, HelpIndex, MessageType, UpdateStatusType } from '../../../models/enums';
import { GenericPickerModalComponent } from '../generic-picker-modal/generic-picker-modal.component';
import * as _ from 'underscore';
import { Permissions, ObjectActionListType } from '../../../models/permission';

@Component({
    standalone: false,
    selector: 'res-generate-more-reports-modal',
    templateUrl: './generate-more-reports-modal.component.html',
    styleUrls: ['./generate-more-reports-modal.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class GenerateMoreReportsModalComponent extends BaseModalComponent implements OnInit {
    isBusy = false;
    isBusyMessage = 'Generating more reports ...';
    options = {
        workFlowTaskHandle: '', selectedExportHandle: '', provideExactGeneratedDocSizes: false,
        selectedExportName: '', generateWorkflowReport: false, finalSearchTermReport: false, exportComparisonReport: false
    };
    exportFilter = '';
    modalClass = 'generate-more-reports-modal';
    modalAutomationId = 'generate-more-reports';
    modalHelpIndex: HelpIndex;
    hasExportPermissions: boolean;

    constructor(
        private modalService: BsModalService,
        private modalRef: BsModalRef,
        private commonService: CommonService,
        private restService: RestService
    ) {
        super(modalService, modalRef);
    }

    ngOnInit() {
        this.hasExportPermissions = Permissions.checkUserPermission(ObjectActionListType.EXPORT_STREAM);
        if (this.modalData && this.modalData.workflow) {
            if (this.modalData.workflow.lastExecutionHandle) {
                this.options.workFlowTaskHandle = this.modalData.workflow.lastExecutionHandle;
                this.modalHelpIndex = HelpIndex.generate_more_reports_workflow_dlg;
            } else {
                this.modalHelpIndex = HelpIndex.generate_workflow_report_run_dlg;
            }

            if (this.modalData.workflow.exportStreamHandle) {
                this.options.exportComparisonReport = true;
                this.options.selectedExportHandle = this.modalData.workflow.exportStreamHandle;
            }
            this.options.finalSearchTermReport = this.modalData.workflow.searchReportHandle ? true : false;
        }

    }

    generateWorkflowReport(): void {
        if (!this.options.generateWorkflowReport) {
            this.options.finalSearchTermReport = false;
            this.options.exportComparisonReport = false;
        }
    }

    finalSearchTermReport(): void {
        if (this.options.finalSearchTermReport) {
            this.options.generateWorkflowReport = true;
        } else {
            this.options.exportComparisonReport = false;
        }
    }

    exportComparisonReport(): void {
        if (this.options.exportComparisonReport) {
            this.options.generateWorkflowReport = this.options.finalSearchTermReport = true;
        } else {
            this.options.selectedExportHandle = '';
            this.options.selectedExportName = '';
        }
    }

    openTargetPicker(): void {
        this.commonService.openModal(GenericPickerModalComponent, { modalData: { entityType: 'export-comparison', items: this.modalData.workflow } }).then(response => {
            if (response && response.modalResult && response.modalData) {
                this.options.selectedExportHandle = response.modalData.export.data.handle;
                this.options.selectedExportName = response.modalData.export.data.name;
                this.options.provideExactGeneratedDocSizes = response.modalData.provideExactGeneratedDocSizes;
            }
        });
    }

    clearExportFilter(): void {
        this.options.selectedExportName = '';
        this.options.selectedExportHandle = '';
    }

    isPrimaryBtnEnabled(): boolean {
        if (this.options.exportComparisonReport) {
            return this.options.workFlowTaskHandle && this.options.finalSearchTermReport && this.options.selectedExportName.length > 0;
        } else {
            return this.options.workFlowTaskHandle && this.options.finalSearchTermReport;
        }
    }

    generateReports(): void {
        const data = {
            workFlowTaskHandle: this.options.workFlowTaskHandle,
            searchTermReporting: this.options.finalSearchTermReport,
            exportStreamHandle: this.options.selectedExportHandle && this.options.selectedExportHandle.length > 0 ? this.options.selectedExportHandle : null,
            provideExactGeneratedDocSizes: this.options.provideExactGeneratedDocSizes
        };
        this.isBusy = true;
        this.restService.post(Endpoint.workFlowManager_addReportToWorkFlow, data).then(response => {
            this.isBusy = false;
            if (response) {
                this.commonService.sendMessage(MessageType.entityChanged, UpdateStatusType.WORK_FLOW);
                setTimeout(() => {
                    this.commonService.sendMessage(MessageType.tabNavigationRequest, this.commonService.selectedNavigationNode.navigationInfo.tabs.filter(t => t.path === 'reports')[0]);
                }, 1000);
            }
        }, error => {
            this.isBusy = false;
        });
        this.closeModal();
    }
}
